export default __webpack_public_path__ + "static/media/t4.afd76561.webp";